<template>
  <div>
    <router-link :to="`/${$route.params.locale}/comic/start`"><button type="button" class="btn btn-outline-primary back-button"><font-awesome-icon icon="chevron-left" class="mr-2" />{{ $t('back_button') }}</button></router-link>
    <p class="h2 text-center mt-sm-4 mt-md-5 mt-4 mb-2">{{ $t('test_knowledge') }}</p>
    <hr class="underline mb-4 mb-sm-4 mb-lg-5">
    <transition name="fade" mode="out-in">
      <div v-if="selected.length != 0 && !selectedAnswer && question < 5" class="test" key="questions">
        <Progress :step="question+1"></Progress>
        <p class="h5 text-uppercase text-center mt-0 mb-2">{{ $t('question_number').replace('$1', question+1) }}</p>
        <hr class="underline mb-3 mb-sm-3 mb-lg-4">
        <div class="image d-flex">
          <img :src="getImage(selected[question].image)">
        </div>
        <p class="question text-center">{{ $t(selected[question].question) }}</p>
        <div class="answers">
          <div class="answer" v-for="(answer,index) in selected[question].answers" :key="answer.text" @click="sendAnswer(answer)">
            <div class="index">
              <p>{{ letters[index] }}</p>
            </div>
            <p class="text">{{ $t(answer.text) }}</p>
          </div>
        </div>
      </div>
      <div v-else-if="selectedAnswer" class="test" key="feedback">
        <Progress :step="question+1"></Progress>
        <p class="h5 text-uppercase text-center mt-0 mb-2" v-if="selectedAnswer.correct == true">{{ $t('question_correct') }}</p>
        <p class="h5 text-uppercase text-center mt-0 mb-2" v-else>{{ $t('question_incorrect') }}</p>
        <hr class="underline mb-3 mb-sm-3 mb-lg-4">
        <p class="feedback-text text-justify" v-html="$t(selectedAnswer.text+'_feedback')"></p>
        <button @click="nextQuestion" class="btn btn-primary ml-auto mr-auto mt-4 mb-2 d-block">{{ $t('vignette_button') }}</button>
      </div>
      <div v-else class="test" key="feedback">
        <p class="h5 text-center mt-3 mb-3">{{ $t('questions_correct').replace('$1', correct).replace('$2', '5') }}</p>
        <hr class="underline mb-3 mb-sm-3 mb-lg-4">
        <p class="h4 mt-5 mb-5 text-center" v-if="correct < 3">{{ $t('question_bad') }}</p>
        <p class="h4 mt-5 mb-5 text-center" v-else-if="correct < 5">{{ $t('question_medium') }}</p>
        <p class="h4 mt-5 mb-5 text-center" v-else>{{ $t('question_perfect') }}</p>
        <button @click="startAgain" class="btn btn-primary ml-auto mr-auto mt-4 mb-2 d-block">{{ $t('try_again') }}</button>
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      
    </transition>
  </div>
</template>

<script>
import json from '@/questions';
import Progress from "@/components/Progress";

export default {
  name: 'vignette',
  components: {
    Progress
  },
  data() {
    return {
      questions: json,
      selected: [],
      letters: ['A', 'B', 'C', 'D'],
      correct: 0,
      question: 0,
      selectedAnswer: null
    }
  },
  created() {
    this.selected = this.getRandom(5);
  },
  methods: {
    getImage(path) {
      return require('@/assets/'+path)
    },
    getRandom(n) {
      let result = new Array(n);
      let len = this.questions.length,
        taken = new Array(len);
      while (n--) {
          var x = Math.floor(Math.random() * len);
          result[n] = this.questions[x in taken ? taken[x] : x];
          taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
    sendAnswer(answer) {
      if (answer.correct == true) {
        this.correct++;
      }
      this.selectedAnswer = answer;
      window.scrollTo(0,0);
    },
    nextQuestion() {
      this.question++;
      this.selectedAnswer = null;
      window.scrollTo(0,0);
    },
    startAgain() {
      this.question = 0;
      this.correct = 0;
      this.selected = this.getRandom(5);
      window.scrollTo(0,0);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "node_modules/bootstrap/scss/functions";
  @import "node_modules/bootstrap/scss/variables";
  @import "node_modules/bootstrap/scss/mixins/_breakpoints";

  p.h2 {
    font-family: 'Kalam', sans-serif;
    text-transform: uppercase;
  }
  .underline {
    margin: 0 auto;
    border-width: 2px;
    max-width: 400px;
    border-color: #e31b18;
    margin-bottom: 25px;
  }

  .test {
    max-width: 660px;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.6);
    border: 1px solid #9abcbf;
    color: rgba(0, 0, 0, 0.8);
    padding: 25px 30px;

    .underline {
      max-width: 180px;
      border-width: 2px;
    }

    .image {
      margin-bottom: 20px;
      img {
        margin: auto;
        max-width: 600px;
        width: 100%;
      }
    }

    .question {
      font-size: 1.1rem;
    }

    .feedback-text {
      font-size: 0.95rem;
    }

    .answers {
      margin-top: 20px;
      .answer {
        margin: 10px auto;
        padding: 15px;
        width: 100%;
        max-width: 600px;
        background: #f0f0f0;
        border: 1px solid #9abcbf;
        color: rgba(0, 0, 0, 0.7);
        cursor: pointer;
        transition: 0.2s all ease-in-out;
        display: flex;
        .index {
          background-color: #f2f2f2;
          border-radius: 50%;
          border: 2px solid #9abcbf;
          min-width: 35px;
          max-width: 35px;
          min-height: 35px;
          max-height: 35px;
          display: flex;
          margin: auto 0;
          margin-right: 10px;
          transition: 0.2s all ease-in-out;
          p {
            transition: 0.2s all ease-in-out;
            margin: auto;
            color: rgba(0, 0, 0, 0.7);
          }
        }
        .text {
          margin: auto 0;
          font-size: 0.95rem;
        }
        &:hover {
          background-color: #9abcbf;
          color: white;
          .index {
            background-color: #9abcbf;
            border: 2px solid #f2f2f2;
            p {
              color: white;
            }
          }
        }
      }
    }
  }

  .back-button {
    position: absolute;
    top: 100px;
    left: 35px;
    @include media-breakpoint-down(sm) {
      position: initial;
      margin-top: 15px;
      margin-bottom: -10px;
    }
  }

  .button-link:hover {
    text-decoration: none;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>

